import Marquee from "react-fast-marquee";

const phrases = ["Você importa", "Você merece", "Você não está sozinha(o)", "Cuidar de si é coragem"];

export default function Ribbon() {
  return (
    <section className="bg-[#EFE7D7] py-8 border-y border-[#5B6E5B]/10" data-testid="ribbon-section">
      <Marquee speed={38} gradient gradientColor="#EFE7D7" gradientWidth={80} autoFill>
        {phrases.map((p, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-2xl sm:text-4xl text-[#2C332A] px-10 sm:px-16">{p}</span>
            <svg width="18" height="18" viewBox="0 0 24 24" className="text-[#C87A5E]" aria-hidden="true">
              <path
                d="M12 3c3 4 6 5 6 9a6 6 0 1 1-12 0c0-4 3-5 6-9Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
